/**
 * Come si traducono le taglie dei widget nella griglia.
 *
 * La griglia ha 2 colonne su telefono e tablet, 4 da schermo largo in su, e
 * righe di altezza fissa. Le classi sono scritte per intero perche' Tailwind
 * genera solo quelle che trova scritte cosi' nel codice.
 *
 * Niente riempimento automatico dei buchi (grid-flow-dense): farebbe apparire
 * i widget in un ordine diverso da quello salvato, e "sposta prima / dopo"
 * non corrisponderebbe piu' a quello che si vede.
 */

import type { Taglia } from '../../lib/dashboard/catalogo';

export const CLASSI_GRIGLIA = 'grid grid-cols-2 xl:grid-cols-4 auto-rows-[10rem] gap-4 md:gap-5';

export const CLASSI_TAGLIA: Record<Taglia, string> = {
  S: 'col-span-1 row-span-1',
  M: 'col-span-2 row-span-1',
  L: 'col-span-2 row-span-2',
  XL: 'col-span-2 row-span-2 xl:col-span-4',
};

export const ETICHETTE_TAGLIA: Record<Taglia, string> = {
  S: 'Piccolo',
  M: 'Medio',
  L: 'Grande',
  XL: 'Tutta la riga',
};

/** Quante righe di elenco stanno in un widget di questa taglia. */
export const RIGHE_ELENCO: Record<Taglia, number> = { S: 0, M: 2, L: 6, XL: 6 };
